import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './ProfileIcon.css'

const propTypes = {
  /** Custom CSS Classes */
  className: PropTypes.string,
  /** User Profile Object */
  profile: PropTypes.object,
}

const ProfileIcon = ({children, className, pictureUrl, ...other}) => {
  const classes = classNames(
    'component-profileIcon',
    styles.profileIcon,
    className
    // propBasedClasses
  )
  const image = pictureUrl || 'https://www.fillmurray.com/40/40'
  return (
    <span {...other} className={classes}>
      <img src={image} height='40px' alt='profile' />
    </span>
  )
}

ProfileIcon.propTypes = propTypes

export default ProfileIcon



// WEBPACK FOOTER //
// ../src/components/ProfileIcon/ProfileIcon.js